/** 0 = fresh, 1–3 = progressively stale. Rendered as a fade toward grey, never a hue (research R-007). */
export type Staleness = 0 | 1 | 2 | 3;

/**
 * How rotten an open action is, from its age.
 *
 * The reference (`TodosHelper.StalenessClass` :543, `DaysStale` :918) subtracts the staleness
 * preference S from the age *and then* compares against S, 2S, 3S — so the steps fall at 2S, 3S and
 * 4S days of age, not the S/2S/3S the code reads like at a glance. Reproduced deliberately; see
 * specs/006-tracks-home/research.md R-005.
 *
 * 009 FR-009: S is `stalenessStarts`, the practitioner's, and a parameter rather than the constant
 * that used to live here. Like `isReviewDue`, this stays a pure function of its arguments — nothing
 * under `shared/` reads `PreferencesStore`; the caller that builds the row supplies the number
 * (`ActionRowLookups.stalenessStarts`, which is required precisely so a caller cannot forget).
 */
export function stalenessFor(createdAt: string, today: Date, stalenessStarts: number): Staleness {
  const ageInDays = Math.floor((today.getTime() - new Date(createdAt).getTime()) / 86_400_000);
  const stale = Math.max(0, ageInDays - stalenessStarts);

  if (stale < stalenessStarts) return 0;
  if (stale < stalenessStarts * 2) return 1;
  if (stale < stalenessStarts * 3) return 2;
  return 3;
}
